import { Injectable } from '@angular/core';
import { Actions, Effect, toPayload } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import { Action, Store } from '@ngrx/store';

import * as fromRoot from '../reducers';
import { TestContentService } from '../../services/test-content.service';

@Injectable()
export class AppUiEffects {
    constructor(
        private store: Store<fromRoot.State>,
        private testContentService: TestContentService
    ) { }
}



// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/store/effects/app-ui.effect.ts